import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController,} from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { SingularityPaymentService } from 'src/app/angular-wallet-base/services/singularity-payment.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getSingularitySession, getWalletConnectInstance, getWalletConnectInstanceNonce } from 'src/app/angular-wallet-base/store/walletConnect';
import { WalletConnectService } from 'src/app/angular-wallet-base/services/wallet-connect.service';
import { IWeb3Wallet } from '@walletconnect/web3wallet';
import { take } from 'rxjs/operators';
import { PriceOracleService } from 'src/app/angular-wallet-base/services/price-oracle.service';
import {  WalletConnectSessionProposalSingularityPairRequestAction } from 'src/app/angular-wallet-base/actions/walletConnect.actions';
import { isSingularityPaymentReady } from 'src/app/angular-wallet-base/store/purchaseOrder.state';
import { SingularityUserCloseDrawer } from 'src/app/angular-wallet-base/actions/singularityPayment.action';
import { getBaseCurrency } from 'src/app/angular-wallet-base/store/userPreferences';
import { isLodeCompanyToken } from 'src/app/angular-wallet-base/utils';
import { CoinGeckoService } from 'src/app/angular-wallet-base/services/coingecko.service';
import { inspect } from 'util';

@Component({
  selector: 'app-singularity-order',
  templateUrl: './singularity-order.component.html',
  styleUrls: ['./singularity-order.component.scss'],
})
export class SingularityOrderComponent implements OnInit {
  public creditCardForm: FormGroup;
 
  public requiredErr: any;
  public asset;
  public showSpinner = false;

  public isSingularityConnected: boolean = false;
  public isConnectingSingularity: boolean = true;
  public fiatValue;
  public totalFiatAmonut;
  public buttonClicked: boolean = false;
  public userCurrency;
  private wcWeb3Wallet:IWeb3Wallet;

  constructor(
    private formBuilder: FormBuilder,
    private nav: NavController,
    private route: ActivatedRoute,
    private authService: AuthService,
    private singularityPaymentService: SingularityPaymentService,
    protected store: Store<AppState>,
    private walletConnectService: WalletConnectService,
    private oraclePriceService: PriceOracleService,
    private coingeckoService: CoinGeckoService
    ) {

  }

  async ngOnInit() {
    this.asset = this.route.snapshot.params.assets;
    this.initForm();
    this.store.select(getWalletConnectInstanceNonce).subscribe(async web3WalletNonce => {
      Logger.info(`getWalletConnectInstanceNonce ${web3WalletNonce}`);
      this.wcWeb3Wallet = await this.store.select(getWalletConnectInstance).pipe(take(1)).toPromise();
      await this.walletConnectService.subscribeProposalSessionFromDapp(this.wcWeb3Wallet);
    });

    this.store.select(getSingularitySession).subscribe(async singularitySession => {
      if (singularitySession) {
        Logger.info(`subscribe getSingularitySession`);
        await this.walletConnectService.subscribeWalletConnectEvents();
       
      }
    })

    this.store.select(isSingularityPaymentReady).subscribe(async isSingularityPaymentReady => {
      const singularitySession = await this.store.select(getSingularitySession).pipe(take(1)).toPromise();
      this.isSingularityConnected = singularitySession && isSingularityPaymentReady ? true: false;
    })
    setTimeout(() => {
      if(!this.isSingularityConnected) {
        this.isConnectingSingularity = false;
      }
    }, 3000);
  }

    getMinValue(): number {
        switch (this.asset) {
          case 'AGX':
            return 50;
          case 'AUX':
            return 800;
          case 'LODE':
            return 10;
          case 'USDC':
            return 35;
          case 'AVAX':
            return 1;
          default:
            return 0; // Set a default value or handle other cases as needed
        }
    }


  initForm() {

    this.creditCardForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.min(this.getMinValue())]],
    });
    this.store.select(getBaseCurrency).subscribe(async (currency) => {
      this.userCurrency = currency;
      this.fiatValue = await this.getTokenFiatValue(this.asset, currency)
    });  
  }

  private async getTokenFiatValue(tokenSymbol: string, currency: string) {
    if (isLodeCompanyToken(tokenSymbol)) {
      const marketPriceFromLodeBackend = await this.oraclePriceService.getMarketPriceFromLodeBackend([tokenSymbol], [currency]);
      return marketPriceFromLodeBackend.fiatValues[tokenSymbol];
    } else if (tokenSymbol == 'USDC'){
      // hardcode need to fix in the future
      const usdcKeyRing = 'AVAX-0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E'
      const coingeckoTokenPrice = await this.coingeckoService.getValueInBaseCurrency([usdcKeyRing], [currency]);
      Logger.info(`token symbol ${inspect(coingeckoTokenPrice)} - test -  ${coingeckoTokenPrice.fiatValues[usdcKeyRing]}`);
      return coingeckoTokenPrice.fiatValues[usdcKeyRing];
    } else {
      const coingeckoTokenPrice = await this.coingeckoService.getValueInBaseCurrency([tokenSymbol], [currency]);
       Logger.info(`token symbol ${inspect(coingeckoTokenPrice)} - test -  ${coingeckoTokenPrice.fiatValues[tokenSymbol]}`);
      return coingeckoTokenPrice.fiatValues[tokenSymbol];
    }
  }


  goBack() {
    this.store.dispatch(new SingularityUserCloseDrawer());
    const previousUrl = this.authService.getPreviousUrl();
    if (previousUrl.includes('/home-page/established') || previousUrl.includes('/buy-assets/')) {
      this.nav.navigateRoot(['/home-page/established']);
    } else {
      this.nav.back();
    }
  }

  navigateToHomePage() {
    this.nav.navigateRoot(['/home-page/established']);
  }

  onAmountChange(event: any) {
    const newValue = event.detail.value; 
    this.totalFiatAmonut =  Number((event.detail.value * this.fiatValue).toFixed(2));
  }

  async startConnectSingularity() {
    Logger.info(`start to connect Singularity`);
    this.isConnectingSingularity = true;
    await this.singularityPaymentService.disconnectAllExistingSingularityTopicSession();
    this.store.dispatch(new WalletConnectSessionProposalSingularityPairRequestAction());
    setTimeout(() => {
      if(!this.isSingularityConnected) {
        this.isConnectingSingularity = false;
      }
    }, 5000);
  }

  markFormGroupAsTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      }
    });
  }

  async onSubmit() {
    this.buttonClicked = true;
    const assetAmount = this.creditCardForm.value.amount;
    this.singularityPaymentService.purchaseTokenByCard(this.asset, assetAmount);
  }

}
